exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-section {\r\n    background-color: #011526;\r\n    padding: 20px;\r\n    border-radius: 2px;\r\n    margin: 10px 0px;\r\n    opacity: 0.95;\r\n}\r\n\r\n.list-section ul {\r\n    list-style: none;\r\n}\r\n\r\n.list-section ul li:hover {\r\n    color: #F2D608;\r\n}\r\n\r\nbutton{\r\n    background-color: transparent;\r\n    border-style: solid;\r\n    border-color: #F2D608;\r\n    border-width: 2px;\r\n    color: #F2D608;\r\n    width: 100px;\r\n    border-radius: 2px;\r\n}\r\n\r\nbutton:hover {\r\n    background-color: gray;\r\n}\r\n\r\nbutton:focus {\r\n    outline: none;\r\n}\r\n\r\nbutton.next {\r\n    float: right;\r\n}\r\n\r\nbutton.prev {\r\n    float: left;\r\n}\r\n\r\n.disabled {\r\n    opacity: 0.3;\r\n}\r\n\r\n.btn-contianer {\r\n    padding-bottom: 25px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/list-view/list-view.component.css
// module id = 310
// module chunks = 2